// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__hycT_","isContentOpened":"styles_isContentOpened__pqDcS","inner":"styles_inner__qKPCB","action":"styles_action__q46__","contentOpened":"styles_contentOpened__6hlF1","iconWrap":"styles_iconWrap__InE08"};
module.exports.__checksum = "2d4edc52eb35"
